<template>
  <div class="account-menu">
  <b-dropdown position="is-bottom-left" aria-role="list">
    <div class="account is-cursor-pointer" slot="trigger">
      <avatar :username="getUserName"
              :size="33" :src="logo">
      </avatar>
    </div>
    <b-dropdown-item
      v-if="utilisateur"
      aria-role="listitem"
      class="pd-0">
      <router-link :class="{'text-access-no-permission':
                     !checkPermissions(permCollaborateur.lecture)}"
        :to="{ name: 'c.parametrage.collaborateurs', params: { id: utilisateur.id }}">
        <div class="media">
          <b-field class="mg-account-menu">
            <b-icon
              :class="{'text-access-no-permission':
                     !checkPermissions(permCollaborateur.lecture)}"
              class="media-left"
              icon="account"
              type="is-default">
            </b-icon>
            <div class="media-content">
              <p class="is-default font-dropdown">{{ $t('general.account')}}</p>
            </div>
          </b-field>
        </div>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" class="pd-0">
      <router-link :to="{ name: 'l.parametrage.general'}" :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.lecture)}">
        <div class="media">
          <b-field class="mg-account-menu">
            <b-icon
              :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.lecture)}"
              class="media-left"
              icon="cog"
              type="is-default">
            </b-icon>
            <div class="media-content">
              <p class="is-default font-dropdown">{{ $t('general.parametrage')}}</p>
            </div>
          </b-field>
        </div>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      aria-role="listitem"
      class="pd-0">
      <router-link
        :to="{ name: 'l.parametrage.sprint'}"
        :class="{'text-access-no-permission': !checkPermissions(constantes.SPRINT.lecture)}">
        <div class="media">
          <b-field class="mg-account-menu">
            <b-icon
              :class="{'text-access-no-permission': !checkPermissions(constantes.SPRINT.lecture)}"
              icon="notebook-outline"
              class="media-left"
              type="is-default">
            </b-icon>
            <div class="media-content">
              <p class="is-default font-dropdown"> {{ $t('sprint.title')}} </p>
            </div>
          </b-field>
        </div>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" class="pd-0">
      <router-link :to="{ name: 'm.parametrage.general-configClient'}"
                   :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.maj)}">
        <div class="media">
          <b-field class="mg-account-menu">
            <b-icon
              :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.maj)}"
              class="media-left"
              icon="cog"
              type="is-default">
            </b-icon>
            <div class="media-content">
              <p class="is-default font-dropdown">
                {{ $t('general.configClient')}}
              </p>
            </div>
          </b-field>
        </div>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" class="pd-0" v-if="isSupport">
      <router-link :to="{ name: 'l.parametrage.general-configInterne'}"
                   :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.maj)}">
        <div class="media">
          <b-field class="mg-account-menu">
            <b-icon
              :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.maj)}"
              class="media-left"
              icon="cog"
              type="is-default">
            </b-icon>
            <div class="media-content">
              <p class="is-default font-dropdown">
                {{ $t('general.configInterne')}}
              </p>
            </div>
          </b-field>
        </div>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" class="pd-0" v-if="isSupport">
      <router-link :to="{ name: 'm.parametrage.general-import'}"
                   :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.maj)}">
        <div class="media">
          <b-field class="mg-account-menu">
            <b-icon
              :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.maj)}"
              class="media-left"
              icon="import"
              type="is-default">
            </b-icon>
            <div class="media-content">
              <p class="is-default font-dropdown">
                {{ $t('general.import')}}
              </p>
            </div>
          </b-field>
        </div>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" class="pd-0" v-if="isSupport">
      <router-link :to="{ name: 'm.parametrage.general-export'}"
                   :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.maj)}">
        <div class="media">
          <b-field class="mg-account-menu">
            <b-icon
              :class="{'text-access-no-permission':
                     !checkPermissions(permGeneral.maj)}"
              class="media-left"
              icon="export"
              type="is-default">
            </b-icon>
            <div class="media-content">
              <p class="is-default font-dropdown">
                {{ $t('general.export')}}
              </p>
            </div>
          </b-field>
        </div>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="isSupport"
      aria-role="listitem"
      class="pd-0"
      @click="openModalChangeUser = true">
      <div class="media">
        <b-field class="mg-account-menu">
          <b-icon
            class="media-left"
            icon="account-convert"
            type="is-default">
          </b-icon>
          <div class="media-content">
            <p class="is-default font-dropdown">
              {{ $t('general.changeUser')}}
            </p>
          </div>
        </b-field>
      </div>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" class="pd-0">
      <div class="media">
        <b-field class="mg-account-menu">
          <b-icon
            class="media-left"
            icon="download"
            type="is-default">
          </b-icon>
          <div class="media-content">
            <a href="https://anydesk.com/fr/downloads"
               target="_blank" class="is-default font-dropdown">
              {{ $t('general.downloadAnyDesk')}}
            </a>
          </div>
        </b-field>
      </div>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" @click="deleteParam()">
      <div class="media">
        <b-icon
          class="media-left"
          icon="trash-can-outline"
          type="is-default">
        </b-icon>
        <div class="media-content">
          <p class="is-default font-dropdown">{{ $t('general.DeleteParam')}}</p>
        </div>
      </div>
    </b-dropdown-item>
    <hr>
    <b-dropdown-item aria-role="listitem" @click="logOut">
      <div class="media">
        <b-icon
          class="media-left"
          icon="logout"
          type="is-default">
        </b-icon>
        <div class="media-content">
          <p class="is-default font-dropdown">{{ $t('general.deconnexion')}}</p>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
  <b-modal
    v-model="openModalChangeUser"
    has-modal-card
    class="modal">
    <pop-up-change-user>
    </pop-up-change-user>
  </b-modal>
  </div>
</template>

<script>

import Avatar from 'vue-avatar';
import { createNamespacedHelpers } from 'vuex';
import inProgress from '@/services/general/inProgress';
import getLogo from '@/services/general/getLogo';
import intToGuid from '@/services/general/transformIntToGuid';
import messageErreur from '@/services/general/messageErreur';
import { COLLABORATEURS, GENERAL, SPRINT } from '@/configuration/general/permissionsParametrageConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import PopUpChangeUser from '@/components/menu/pChangeUser';

const parametres = createNamespacedHelpers('parametres');
const user = createNamespacedHelpers('user');
const permissions = createNamespacedHelpers('permissions');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  name: 'AccountMenu',
  data() {
    return {
      logo: null,
      permCollaborateur: COLLABORATEURS,
      permGeneral: GENERAL,
      openModalChangeUser: false,
      constantes: {
        SPRINT,
      },
    };
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...user.mapGetters({
      utilisateur: 'user',
      site: 'site',
      isSupport: 'isSupport',
    }),
    getUserName() {
      if (!this.utilisateur) return '';
      return nomPrenomGetter(this.utilisateur);
    },
  },
  components: {
    Avatar,
    PopUpChangeUser,
  },
  methods: {
    ...parametres.mapActions({
      purgerParametres: 'purgerParametres',
    }),
    ...user.mapActions({
      actionLogOut: 'logOut',
    }),
    ...permissions.mapActions({
      permissionLogOut: 'logOut',
    }),
    ...CategorieVente.mapActions({
      purgerCategorieVente: 'purgerCategorieVente',
    }),
    async logOut() {
      await this.$router.push({ name: 'connexion', query: { site: this.site } });
      await this.purgeParam();
      await this.permissionLogOut();
      await this.actionLogOut();
    },
    async deleteParam() {
      this.purgeParam();
      await this.purgerCategorieVente();
      this.$router.go(0);
    },
    purgeParam() {
      this.purgerParametres();
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.logo = await getLogo(intToGuid(this.utilisateur.id));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
